import React from 'react';
import classNames from 'classnames';

import { useTranslation } from '@lt/localization';
import { Bubble } from '@lt/components';
import {
  TransferOn as TransferOnIcon,
  TransferOff as TransferOffIcon,
  InsuranceOn as InsuranceOnIcon,
  InsuranceOff as InsuranceOffIcon,
  QuestionOutline as QuestionIcon,
} from '@lt/components/icons-react/rebrand';
import PopupTransfer from './components/PopupTransfer';
import PopupInsurance from './components/PopupInsurance';
import type { IHotelAirport } from '../../store/hotel/types';

import styles from './transferMedInsuranceInfo.module.css';

interface Props {
  sidebar: boolean;
  insurance: boolean;
  transfer: boolean;
  transferPrivate: boolean;
  airports?: IHotelAirport[];
  isMobile?: boolean;
}

export const TransferMedInsuranceInfo = ({
  sidebar,
  insurance,
  transfer,
  transferPrivate,
  airports,
  isMobile = false,
}: Props) => {
  const { t } = useTranslation();
  const TransferIcon = transfer ? TransferOnIcon : TransferOffIcon;
  const InsuranceIcon = insurance ? InsuranceOnIcon : InsuranceOffIcon;
  return (
    <div
      className={classNames(styles.root, {
        [styles.sidebar]: sidebar,
      })}
    >
      {!sidebar && (
        <div className={styles.title}>{t('checkout.flight.includedWith')}</div>
      )}
      <div
        className={classNames(styles.list, {
          [styles.mobileList]: isMobile,
          [styles.desktopList]: !isMobile,
        })}
      >
        <div className={styles.row}>
          <TransferIcon
            className={classNames(styles.icon, {
              [styles.notIncludedIcon]: !transfer,
            })}
          />
          <div
            className={classNames(styles.info, {
              [styles.notIncludedInfo]: !transfer,
            })}
          >
            {transfer
              ? t('checkout.packageInfo.transfer.included')
              : t('checkout.packageInfo.transfer.not_included')}
          </div>
          {!sidebar && (
            <Bubble
              renderExtras={() =>
                PopupTransfer({
                  transfer,
                  airports,
                  transferPrivate,
                  isMobile,
                  t,
                })
              }
              text=" "
            >
              <QuestionIcon
                className={classNames(styles.icon, styles.questionIcon, {
                  [styles.notIncludedIcon]: !transfer,
                })}
              />
            </Bubble>
          )}
        </div>
        <div className={styles.row}>
          <InsuranceIcon
            className={classNames(styles.icon, {
              [styles.notIncludedIcon]: !insurance,
            })}
          />
          <div
            className={classNames(styles.info, {
              [styles.notIncludedInfo]: !insurance,
            })}
          >
            {insurance
              ? t('checkout.packageInfo.medInsurance.included')
              : t('checkout.packageInfo.medInsurance.not_included')}
          </div>
          {!sidebar && (
            <Bubble
              renderExtras={() => PopupInsurance({ insurance, t })}
              text=" "
            >
              <QuestionIcon
                className={classNames(styles.icon, styles.questionIcon, {
                  [styles.notIncludedIcon]: !insurance,
                })}
              />
            </Bubble>
          )}
        </div>
      </div>
    </div>
  );
};
